import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MonitorService } from '@domain/infrastructure/api/monitor/monitor.service';

import { AssetLink } from '@utils/helpers/asset-cpm-link';

@Component({
  selector: 'ba-btn-trigger',
  templateUrl: './btn-trigger.component.html',
  styleUrls: ['./btn-trigger.component.scss'],
})
export class BtnTriggerComponent extends AssetLink() {
  @Input() filled: boolean = true;

  @Output() trigger = new EventEmitter<void>();

  constructor(private monitorService: MonitorService) {
    super();
  }

  ngOnInit() {
    this.monitorService.startMonitorData();
  }
}
